export default {
  errorMessage:
    "The content you are trying to see failed to load. Please try again or come back a little later.",
  errorTitle: "It's not you, it's us!"
};
